<script>
import crud from '@/crud/form/form'
import resources from './resources'

export default {
  name: 'professional-covenants-create',
  mixins: [crud, resources]
}
</script>

<template lang="pug">
page(title="Convênios Atendidos por Estabelecimento", icon="")
  .col-xs-12.content
    .container-fluid
      .row
        medibook-alert-custom(
          :show='show',
          @close='show = false',
          title='Perfeito',
          type='sa-success',
          message='Convênio incluido com sucesso.',
          :buttonsNext='nextStepButtonCompanyCovenants',
          v-if="wasRaised && userIsCompany")

        medibook-alert-custom(
          :show='show',
          @close='show = false',
          title='Perfeito',
          type='sa-success',
          message='Convênio incluido com sucesso.',
          :buttonsNext='nextStepButtonIsCompanyCovenants',
          v-if="wasRaised && !userIsCompany")

        ul.nav.nav-tabs
          li
            router-link(:to="{ name: 'professional.company.covenants.index'}")
                a(href='#') Listagem
          li.active
            a(href='#') Cadastro
        .col-xs-12.white-bg
          .row
            .col-xs-12
              div.col-sm-10
                .space
                h4 ESTABELECIMENTO — CONVÊNIOS
                .form-group
                  v-input(:status="$v.covenant.covenant_id.$error ? 'error' : null")
                    f-select-covenant(label="Convênio",
                       name="covenant",
                       v-model="covenant.covenant_id",
                       :get-all="true",
                       :searchable="true",
                       :errors="errors['covenant_id']",
                       :parameters="{limit: 100}"
                       @selected="setPlansFromCovenant")

                .form-group
                  f-select(
                    :value="covenant.plan_id",
                    v-if="covenant.covenant_id",
                    label="Plano de Saúde (opcional)",
                    name="plans", v-model="covenant.plans",
                    :options="plans",
                    :searchable="false",
                    :multiple="true",
                    :errors="errors['plan_id']")

                .form-group
                    f-select(label="Status",
                       name="active",
                       v-model="covenant.active",
                       :options="activeOptions",
                       :searchable="false",
                       :errors="errors['active']")

                .row.border-bottom
                .buttons-wrapper(v-if="!saved")
                  button.btn.save(@click.prevent="doSave()")
                    span.icon 
                    |  Salvar Convênio
</template>



// WEBPACK FOOTER //
// src/app/professional/company/covenants/create/create.vue